export default __webpack_public_path__ + "sounds/framework/5SPREAD_R.fe2bba01.mp3?fe2bba01";